var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function createStateContext(initialState) { return /*#__PURE__*/ createContext({ state: initialState, dispatch: function () { throw new Error('Dispatcher is not set to the context'); } }); }
export function withStateContext(ContextProvider, Component) { function ComponentWithStateContext(props) { return /*#__PURE__*/ _jsx(ContextProvider, { children: /*#__PURE__*/ _jsx(Component, __assign({}, props)) }); } return ComponentWithStateContext; }
